import Vue from 'vue'
import App from './App.vue'


/* import VueRouter from 'vue-router'
Vue.use(VueRouter) */

import VueAnimate from 'vue-animate-scroll'

Vue.use(VueAnimate)


Vue.config.productionTip = false

/* const routes = [{
    path: '/',
    component: Main
  },
  {
    path: '/alfred',
    component: Alfred
  },
  {
    path: '/watcher',
    component: Watcher
  }
]

const router = new VueRouter({
  routes // short for `routes: routes`
}) */

new Vue({
  // router,
  render: h => h(App),
}).$mount('#app')